var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 13.3323H13.3357V0C20.6945 0 26.668 5.9735 26.668 13.3323Z",
    fill: "#EB6F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 13.3323H13.3357V0C20.6945 0 26.668 5.9735 26.668 13.3323Z",
    fill: "#EB6F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 13.3333H13.334C18.2682 13.3333 22.5727 16.0159 24.8789 20.0002C26.0138 18.0384 26.6678 15.7625 26.6678 13.3333H26.6663Z",
    fill: "#F1BCB8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 26.6667C26.668 34.0255 20.6945 39.999 13.3357 39.999V26.6667H26.668Z",
    fill: "#7BAC98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.877 20.0002C22.5707 16.0159 18.2662 13.3333 13.332 13.3333V26.6656H26.6643C26.6643 24.2364 26.0119 21.9605 24.8754 19.9987L24.877 20.0002Z",
    fill: "#EB6F4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 26.6656V13.3333H-0.000246048V26.6656H13.332Z",
    fill: "#7BAC98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00170422 40H13.334L13.334 26.6677H0.00170422L0.00170422 40Z",
    fill: "#F1BCB8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.3323V0L0.00170422 0V13.3323H13.334Z",
    fill: "#FFC94E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbLogoNoText);
export default __webpack_public_path__ + "static/media/bb-logo-no-text.da0d868dd6dd940484c41e1fba6e4000.svg";
export { ForwardRef as ReactComponent };